import { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';

class NumberInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
  }

  onChangeHandler(e) {
    this.setState({ value: e.target.value });

    this.props.onChangeHandler(e);
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(e);
  }

  onKeyDownHandler(e) {
    this.props.onKeyDownHandler(e);
  }

  render() {
    const {
      id,
      name,
      label,
      className,
      min,
      max,
      errors,
      readOnly,
      inputRef,
      autoFocus,
    } = this.props;

    let inputClassNames = 'form-control';
    if (this.state.value !== '') {
      inputClassNames += ' has-content';
    }


    let classNames = 'input-field';
    if (className) {
      classNames += ` ${className}`;
    }

    if (hasErrors(errors)) {
      classNames += ' has-errors';
    }

    return (
      <div>
        <div className={classNames}>
          <input
            ref={inputRef}
            autoFocus={autoFocus}
            value={this.state.value}
            readOnly={readOnly}
            type="number"
            name={name}
            id={id}
            onKeyDown={this.onKeyDownHandler}
            onChange={this.onChangeHandler}
            onBlur={this.onBlurHandler}
            className={inputClassNames}
            min={min}
            max={max}
          />
          <label htmlFor={id}>{label}</label>
        </div>
        <ErrorComponent errors={errors} />
      </div>
    );
  }
}

NumberInputComponent.propTypes = {
  id: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onKeyDownHandler: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  inputRef: PropTypes.object,
};

NumberInputComponent.defaultProps = {
  readOnly: false,
  className: null,
  autoFocus: false,
  value: '',
  min: null,
  max: null,
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  onKeyDownHandler: () => {},
  errors: null,
  inputRef: null,
};

export default NumberInputComponent;
